import { desktopMediaQueryString, mediumScreenMediaQueryString, mobileMediaQueryString } from './breakpoints'

// For the main <Layout> that wraps most pages
export default `

@media only screen and ${mobileMediaQueryString} {
    .is-container-app .legacy-layout-wrapper.legacy-full-height {
        padding-top: 0;
    }

    .legacy-layout-wrapper:not(.legacy-full-height):not(.legacy-has-hero-image).legacy-has-mobile-nav-bar {
        padding-top: 56px;
    }

    .legacy-layout-wrapper:not(.legacy-full-height),
    .legacy-has-primary-mobile-nav:not(.legacy-full-height) {
        padding-top: 56px;
    }

    .legacy-layout-wrapper.legacy-has-no-mobile-nav:not(.legacy-full-height) {
        padding-top: 0;
    }

    .is-container-app .legacy-layout-wrapper.legacy-has-primary-mobile-nav:not(.legacy-full-height) {
        padding-top: 0;
        padding-bottom: 120px;
    }

    .legacy-layout-wrapper.legacy-full-height.legacy-has-primary-mobile-nav {
        padding-top: 56px;
    }

    .is-container-app .legacy-layout-wrapper.legacy-full-height.legacy-has-primary-mobile-nav {
        padding-top: 0;
        padding-bottom: 56px;
    }

    .legacy-is-eligible-for-upgrade .is-container-app .legacy-layout-wrapper:not(.legacy-has-mobile-nav-bar) {
        padding-top: 0;
    }

    .legacy-is-eligible-for-upgrade .legacy-layout-wrapper:not(.legacy-full-height):not(.legacy-has-hero-image).legacy-has-mobile-nav-bar {
        padding-top: 80px; /* For nav promotion */
    }

}


/* Desktop -- this must come BEFORE the tablet styles because there is some overlap in the media query */
@media only screen and ${desktopMediaQueryString} {
    .legacy-layout-wrapper {
        padding-top: 72px;
    }

    .legacy-layout-wrapper.legacy-has-hero-image {
        padding-top: 72px;
    }

    .legacy-layout-wrapper.legacy-full-height {
        padding-top: 80px;
    }

    .legacy-is-eligible-for-upgrade .legacy-layout-wrapper:not(.legacy-has-hero-image):not(.legacy-full-height) {
        padding-top: 104px; /* For nav promotion */
    }
}

/* Tablet -- this must come AFTER the desktop styles because there is some overlap in the media query */
@media only screen and ${mediumScreenMediaQueryString} {
    .legacy-layout-wrapper {
        padding-top: 56px;
    }

    .legacy-layout-wrapper.legacy-has-hero-image {
        padding-top: 56px;
    }

    .legacy-is-eligible-for-upgrade .legacy-layout-wrapper {
        padding-top: 88px;
    }

    .legacy-is-eligible-for-upgrade .legacy-layout-wrapper.legacy-has-hero-image {
        padding-top: 56px;
    }
}
`
